import React, { useState, useEffect, useContext } from 'react'
import AssetFilter from '../AssetManager/AssetFilter'
import ChannelCard from './ChannelCard'
import CreateChannelModal from './CreateChannelModal'
import './iptv.css'
import PlusIcon from 'src/assets/white-plus-black-bg.svg'
import { CButton } from '@coreui/react'
import { useHistory } from 'react-router-dom'
import useAxios from 'axios-hooks'
import {
  COUNTRY_API,
  SUBSCRIPTION_API,
  SYSTEM_METADATA_API,
  CONTENT_RATING_API,
  IPTV_CHANNEL_API,
  IPTV_CHANNEL_FILTER,
} from 'src/views/utils/urls'
import { AppContext } from 'src/views/context/app'
import { checkPermissions, getThumbnail, raiseToast } from 'src/views/utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'
import InfiniteScroll from 'react-infinite-scroll-component'
import { PERMISSIONS } from 'src/views/utils/permissions'

const IPTVChannels = () => {
  const history = useHistory()
  const { setLoader, accountObj } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const language = localStorage.getItem('language')
  const defaultLangCheck = language === accountObj?.default_language
  const isCreateAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.IPTV_MODULE.CREATE) &&
    defaultLangCheck

  const [channels, setChannels] = useState([])
  const [page, setPage] = useState(1)
  const [filterPayloadObj, setFilterPayloadObj] = useState({})

  const [searchText, setSearchText] = useState('')
  const [categoryFilter, setCategoryFilter] = useState([])
  const [subscriptionFilter, setSubcriptionFilter] = useState([])
  const [PPVFilter, setPPVFilter] = useState([])
  const [statusFilter, setStatusFilter] = useState('')
  const [categoryMasterData, setCategoryMasterData] = useState([])
  const [subscriptionMasterData, setSubscriptionMasterData] = useState([])
  const [ppvMasterData, setPPVMasterData] = useState([])
  const [filters, setFilters] = useState([])
  const [editChannel, setEditChannel] = useState({})

  const [{ data: countryList, loading: countryLoading }] = useAxios({
    url: COUNTRY_API,
    method: 'get',
  })

  const [{ data: subscriptionList, loading: subscriptionListLoading }] = useAxios({
    url: SUBSCRIPTION_API,
    method: 'get',
  })

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  const [{ data: contentRatingList, loading: contentRatingLoading }] = useAxios({
    url: CONTENT_RATING_API,
    method: 'get',
  })

  const [{ data: channelCreationData, loading: channelCreationLoading }, channelCreationCall] =
    useAxios(
      {
        url: IPTV_CHANNEL_API,
        method: 'post',
      },
      {
        manual: true,
      },
    )
  const [{ data: channelUpdateData, loading: channelUpdateLoading }, channelUpdateCall] = useAxios(
    {
      url: IPTV_CHANNEL_API,
      method: 'put',
    },
    {
      manual: true,
    },
  )
  const [{ data: channelList, loading: channelListLoading }, channelListCall] = useAxios(
    {
      url: IPTV_CHANNEL_FILTER,
      method: 'post',
    },
    {
      manual: true,
    },
  )

  useEffect(() => {
    if (categoryList && categoryList.success) {
      setCategoryMasterData(
        categoryList?.data?.filter((info) => info.status && info.type === 'category'),
      )
    }
  }, [categoryList])

  useEffect(() => {
    if (subscriptionList && subscriptionList.success) {
      setSubscriptionMasterData(
        subscriptionList?.data?.filter((info) => info.status && info.type === 'normal'),
      )
      setPPVMasterData(subscriptionList?.data?.filter((info) => info.status && info.type === 'ppv'))
    }
  }, [subscriptionList])

  const filterIntialValue = [
    {
      title: 'Category',
      type: 'checkbox',
      checkedState: '',
      options: categoryMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(0, setCategoryFilter, checked, value)
      },
    },
    {
      title: 'Subscription',
      type: 'checkbox',
      checkedState: '',
      options: subscriptionMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(1, setSubcriptionFilter, checked, value)
      },
    },
    {
      title: 'PPV',
      type: 'checkbox',
      checkedState: '',
      options: ppvMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(2, setPPVFilter, checked, value)
      },
    },
    {
      title: 'Status',
      type: 'radio',
      checkedState: '',
      options: [
        { name: 'Enabled', value: 'true' },
        { name: 'Disabled', value: 'false' },
      ],
      onSelect: (value) => {
        onstatusFilterChange(value)
      },
    },
  ]

  useEffect(() => {
    if (filters.filter((info) => info.checkedState !== '').length === 0) {
      setFilters([
        {
          title: 'Category',
          type: 'checkbox',
          checkedState: '',
          options: categoryMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(0, setCategoryFilter, checked, value)
          },
        },
        {
          title: 'Subscription',
          type: 'checkbox',
          checkedState: '',
          options: subscriptionMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(1, setSubcriptionFilter, checked, value)
          },
        },
        {
          title: 'PPV',
          type: 'checkbox',
          checkedState: '',
          options: ppvMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(2, setPPVFilter, checked, value)
          },
        },
        {
          title: 'Status',
          type: 'radio',
          checkedState: '',
          options: [
            { name: 'Enabled', value: 'true' },
            { name: 'Disabled', value: 'false' },
          ],
          onSelect: (value) => {
            onstatusFilterChange(value)
          },
        },
      ])
    }
  }, [categoryMasterData, subscriptionMasterData, ppvMasterData])

  useEffect(() => {
    channelListCall({
      data: {
        filters: {},
        order_by: 'modified_date',
        reverse: true,
        page: page,
      },
    })
  }, [])

  useEffect(() => {
    let payload = {
      system_defined: [
        {
          key: 'category',
          name: 'Category',
          filter_type: 'AND',
          operator: 'eq',
          values: categoryFilter,
        },
        {
          key: 'active_subscription',
          name: 'Subscription',
          filter_type: 'AND',
          operator: 'eq',
          values: subscriptionFilter,
        },
        {
          key: 'active_ppv',
          name: 'PPV',
          filter_type: 'AND',
          operator: 'eq',
          values: PPVFilter,
        },
      ],
      search_text: searchText,
      // status: statusFilter,
    }
    if (typeof statusFilter !== 'string') {
      payload['status'] = statusFilter
    }
    console.log('payload', payload)
    setFilterPayloadObj(payload)
  }, [searchText, PPVFilter, subscriptionFilter, categoryFilter, statusFilter])

  useEffect(() => {
    if (channelCreationData && channelCreationData.success) {
      setShowCreateChannel(false)
      resetFilters()
      raiseToast('success', 'Channel Created Successfully')
    }
  }, [channelCreationData])

  useEffect(() => {
    if (channelUpdateData && channelUpdateData.success) {
      setShowCreateChannel(false)
      resetFilters()
      raiseToast('success', 'Channel Updated Successfully')
    }
  }, [channelUpdateData])

  useEffect(() => {
    if (channelList && channelList.success) {
      page === 1
        ? setChannels(channelList.data)
        : setChannels((channel) => [...channel, ...channelList.data])
    }
  }, [channelList])

  useEffect(() => {
    setLoader(
      countryLoading ||
        subscriptionListLoading ||
        categoryListLoading ||
        contentRatingLoading ||
        channelCreationLoading ||
        channelListLoading ||
        channelUpdateLoading,
    )
  }, [
    countryLoading,
    subscriptionListLoading,
    categoryListLoading,
    contentRatingLoading,
    channelCreationLoading,
    channelListLoading,
    channelUpdateLoading,
  ])

  const [showCreateChannel, setShowCreateChannel] = useState(false)

  const handleSaveChannel = (payload) => {
    channelCreationCall({ data: payload })
  }
  const handleUpdateChannel = (payload, id) => {
    channelUpdateCall({
      params: {
        channel_id: id,
      },
      data: payload,
    })
  }

  const handleSearch = (value) => {
    setPage(1)
    setSearchText(value)
    channelListCall({
      data: {
        filters: { ...filterPayloadObj, search_text: value },
        page: 1,
        order_by: 'modified_date',
        reverse: true,
      },
    })
  }

  const handleNextPage = () => {
    channelListCall({
      data: {
        filters: filterPayloadObj,
        page: page + 1,
        order_by: 'modified_date',
        reverse: true,
      },
    })
    setPage((page) => page + 1)
  }

  const applyFilter = () => {
    setPage(1)
    channelListCall({
      data: {
        filters: filterPayloadObj,
        page: 1,
        order_by: 'modified_date',
        reverse: true,
      },
    })
  }

  const resetFilters = () => {
    setFilters(filterIntialValue)
    setCategoryFilter([])
    setSubcriptionFilter([])
    setPPVFilter([])
    setStatusFilter('')
    setPage(1)
    channelListCall({
      data: {
        filters: { search_text: searchText },
        page: 1,
        order_by: 'modified_date',
        reverse: true,
      },
    })
  }

  const onstatusFilterChange = (value) => {
    setStatusFilter(value === '' ? '' : value === 'true' ? true : false)
    handleFilterChange(3, value)
  }

  const onFilterChange = (index, setStateFunc, checked, value) => {
    if (checked) {
      setStateFunc((prev) => {
        handleFilterChange(index, [...prev, value])
        return [...prev, value]
      })
    } else {
      setStateFunc((prev) => {
        handleFilterChange(
          index,
          [...prev].filter((type) => type !== value),
        )
        return [...prev].filter((type) => type !== value)
      })
    }
  }

  const handleFilterChange = (index, value) => {
    setFilters((prev) => {
      prev[index] = { ...prev[index], checkedState: value }
      return [...prev]
    })
  }
  const handleEdit = (info) => {
    setEditChannel(info)
    setShowCreateChannel(true)
  }

  return (
    <>
      <div style={{ color: '#191818' }}>
        <h1 style={{ fontSize: '30px', marginBlockEnd: '0', fontWeight: 'bolder' }}>IPTV</h1>
        <p style={{ fontSize: '18px', fontWeight: '500' }}>Mange your IPTV Channels</p>
        <div
          style={{
            background: 'white',
            border: '1px solid #70707050',
          }}
        >
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              padding: '1.42vw 1.5vw 0',
              margin: '0 auto 3vh',
              width: '100%',
              position: 'relative',
            }}
          >
            <div>
              <AssetFilter
                filters={filters}
                onSearch={handleSearch}
                onApply={applyFilter}
                onClearAll={resetFilters}
                dropdownHeight={'300px'}
              />
            </div>

            <CButton
              style={{
                background: '#20211c',
                border: 'none',
              }}
              className="text-white py-2 px-4 position-absolute end-6"
              onClick={() => {
                setEditChannel({})
                setShowCreateChannel(true)
              }}
              disabled={!isCreateAllowed}
            >
              Add Channel
            </CButton>
          </div>
          <div style={{ height: '34vw' }} className="border-top  mx-1">
            <InfiniteScroll
              dataLength={channels.length} //This is important field to render the next data
              next={handleNextPage}
              hasMore={channelList && channelList.total > page * 20}
              style={{ overflowX: 'hidden' }}
              loader={<p>Loading...</p>}
              className="static-scrollbar-class"
              height={`34vw`}
              scrollableTarget="scrollableDiv"
            >
              <div
                className=" d-flex flex-wrap"
                style={{
                  gap: '2.4vw 3.34%',
                  padding: '20px .5vw 20px 1vw',
                }}
              >
                {[...channels].map((channel, idx) => (
                  <ChannelCard
                    key={idx}
                    title={channel?.name}
                    cardImage={getThumbnail(
                      userSessionObj.session_data.cf_domain_name,
                      channel?.thumbnail?.website?.s3_key,
                    )}
                    category={channel?.category.map((info) => info.name).slice(0, 2)}
                    pricing={channel?.is_restricted ? 'Paid' : 'Free'}
                    actionButtonOptions={[
                      {
                        name: 'Edit',
                        btnFunction: () => {
                          handleEdit(channel)
                        },
                      },
                      {
                        name: 'Schedule',
                        btnFunction: () => {
                          history.push(`/iptv-schedule/${channel._id}`)
                        },
                      },
                    ]}
                  />
                ))}
                <div
                  style={{
                    width: '17.14%',
                    aspectRatio: '251/189',
                    boxShadow: '3px 3px 8px 0 rgba(0, 0, 0, 0.2)',
                    border: `.5px solid #707070`,
                    borderRadius: '4px',
                    overflow: 'hidden',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setEditChannel({})
                    setShowCreateChannel(true)
                  }}
                >
                  <div
                    className="relative d-flex justify-content-center align-items-center flex-column gap-2"
                    style={{ height: '74%', background: '#ececec' }}
                  >
                    <img src={PlusIcon} />
                    <h6
                      style={{ fontSize: '12px', margin: '.2ch 0 .4ch', color: '#000' }}
                      role="button"
                    >
                      Add a new Channel
                    </h6>
                  </div>
                  <div className="bg-white" style={{ height: '26%' }}></div>
                </div>
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </div>

      {showCreateChannel && (
        <CreateChannelModal
          subscriptionMaster={subscriptionList?.data.filter(
            (info) => info.status && info.type === 'normal',
          )}
          PPVMaster={subscriptionList?.data.filter((info) => info.status && info.type === 'ppv')}
          countriesMaster={countryList?.data}
          categoryMaster={categoryList?.data.filter(
            (info) => info.status && info.type === 'category',
          )}
          ratingMaster={contentRatingList?.data.filter((info) => info.status)}
          onCancel={() => {
            setEditChannel({})
            setShowCreateChannel(false)
          }}
          onCreate={handleSaveChannel}
          onUpdate={handleUpdateChannel}
          data={editChannel}
        />
      )}
    </>
  )
}

export default IPTVChannels
